import { Box, SxProps, Theme, useMediaQuery } from '@mui/material';
import { Outlet } from 'react-router-dom';

import CsiModal from 'app/components/CsiModal';
import Loader from 'app/components/Loader';
import NotificationModal from 'app/widgets/notification-modal';
import { getTheme } from 'app/components/ThemeProvider/theme';
import { useFormCsi } from 'app/providers/csi/hooks/useFormCsi';
import EmptyStateDialog from 'app/shared/ui/elements/EmptyStateDialog';
import useEmptyStateDialog from 'app/store/ui/useEmptyStateDialog';
import Header from 'app/widgets/header';
import SidebarMenu from 'app/widgets/sidebar-menu';
import { bg } from './MainLayout.sx';

interface LayoutProps {
  isLoading: boolean;
  data: any;
  isMaintainable?: boolean;
  contentSx?: SxProps<Theme>;
}

const MainLayout = (props: LayoutProps) => {
  const {
    data: dataHeaderAndMenu,
    isLoading: isLoadingHeaderAndMenu,
    isMaintainable = false,
  } = props;
  const theme = getTheme();
  const mediumScreens = useMediaQuery(theme.breakpoints.down('md'));
  const formCsi = useFormCsi();
  const { isOpen: isEmptyStateDialogOpen, close: closeEmptyStateDialog } = useEmptyStateDialog();

  const SideBarMenu = (_props?: Function) => (
    <SidebarMenu
      menu={dataHeaderAndMenu?.main_menu}
      sign={dataHeaderAndMenu?.user?.company?.employee.sign_type}
      title={dataHeaderAndMenu?.user?.company?.title}
      {..._props}
    />
  );

  if (isLoadingHeaderAndMenu) {
    return <Loader />;
  }

  return (
    <Box>
      <Header
        menu={dataHeaderAndMenu?.main_menu}
        sign={dataHeaderAndMenu?.user?.company?.employee.sign_type}
        title={dataHeaderAndMenu?.user?.company?.title}
        user={dataHeaderAndMenu?.user}
        mailbox={dataHeaderAndMenu?.mailbox_unread}
        isDisabled={!isMaintainable}
      >
        {(_props: Function) => SideBarMenu(_props)}
      </Header>
      <Box sx={{ display: 'flex' }}>
        {!mediumScreens && SideBarMenu()}
        <Box
          sx={[
            ...(Array.isArray(bg) ? bg : [bg]),
            ...(Array.isArray(props.contentSx) ? props.contentSx : [props.contentSx ?? {}]),
          ]}
        >
          <Outlet
            context={{
              inn: dataHeaderAndMenu?.user?.company?.inn,
              title: dataHeaderAndMenu?.user?.company?.title,
              signMethod: dataHeaderAndMenu?.user?.company?.employee.method,
              signType: dataHeaderAndMenu?.user?.company?.employee.sign_type,
              companyId: dataHeaderAndMenu?.user?.company?.id,
              employeeId: dataHeaderAndMenu?.user?.company?.employee.id,
              userId: dataHeaderAndMenu?.user?.id,
            }}
          />
        </Box>
      </Box>
      {isMaintainable && (
        <>
          <CsiModal
            open={formCsi.isOpen}
            close={() => {}}
            approveAction={formCsi.submit}
            showText={true}
          />
          <NotificationModal />
        </>
      )}
      <EmptyStateDialog open={isEmptyStateDialogOpen} onClose={closeEmptyStateDialog} />
    </Box>
  );
};

export default MainLayout;
